import type { Key } from "./en";

// Typed against the English dictionary: adding a key there breaks this file
// until it is translated, which is the whole point of keeping the type.
export const es: Record<Key, string> = {
  "app.tagline": "Convertí una imagen en un SVG listo para la Cricut",
  "app.account": "Tu cuenta",
  "app.back": "Volver",
  "app.signOut": "Salir",
  "update.available": "Hay una versión nueva de crikea.",
  "update.reload": "Recargar",

  "source.drop": "Soltá una imagen acá, o",
  "source.browse": "buscala",
  "source.hint": "PNG o JPG. El line art es lo que mejor sale.",
  "source.replace": "Cambiar la imagen",
  "source.clean": "Limpiar con IA",
  "source.cleaning": "Limpiando…",
  "source.cleanHint": "Saca el fondo y lo deja en negro sobre blanco.",
  "source.erase": "Borrar zonas",
  "source.eraseDone": "Listo",
  "source.eraseHint": "Arrastrá sobre lo que no querés cortar.",
  "erase.aria": "Arrastrá para borrar partes del diseño",
  "source.compare": "Comparar con la original",

  "params.mode": "Modo",
  "params.mode.cut": "Cortar",
  "params.mode.draw": "Dibujar",
  "params.side": "Fijar el",
  "params.side.width": "ancho",
  "params.side.height": "alto",
  "params.size": "Tamaño",
  "params.rotation": "Rotación",
  "params.thicken": "Engrosado",
  "params.thickenAuto": "Automático",
  "params.thickenHint":
    "Los trazos finos no sobreviven a la cuchilla. El valor por defecto sigue al material.",

  "audit.title": "Chequeo",
  "audit.thinnest": "Trazo más fino",
  "audit.nodes": "Nodos",
  "audit.size": "Tamaño final",
  "audit.ok": "Listo para cortar",
  "audit.warn": "Se puede cortar, con riesgo",
  "audit.fail": "No va a cortar bien",
  "audit.busy": "Midiendo…",

  "action.download": "Descargar SVG",
  "action.save": "Guardar en el historial",
  "action.saving": "Guardando…",
  "action.saved": "Guardado en tu historial.",

  "history.title": "Historial",
  "history.empty": "Todavía no guardaste nada.",
  "history.yours": "Tus diseños",
  "history.emptyLong": "Todavía no guardaste ninguno. Convertí una imagen y guardala para tenerla acá.",
  "history.loadingYours": "Cargando tu historial…",
  "history.deleteLabel": "Borrar {name}",
  "history.open": "Abrir",
  "history.delete": "Borrar",
  "history.confirmDelete": "¿Borrar este diseño?",
  "history.loading": "Cargando…",

  "auth.signIn": "Entrar",
  "auth.email": "Correo",
  "auth.password": "Contraseña",
  "auth.signingIn": "Entrando…",
  "auth.forgot": "¿Olvidaste la contraseña?",
  "auth.passkey": "Entrar con la huella",
  "auth.passkeyHint": "Sin correo ni contraseña.",
  "auth.backToSignIn": "Volver a entrar",

  "reset.title": "Elegí una contraseña nueva",
  "reset.new": "Contraseña nueva",
  "reset.confirm": "Repetila",
  "reset.submit": "Guardar la contraseña",
  "reset.saving": "Guardando…",
  "reset.mismatch": "Las dos contraseñas no coinciden.",
  "reset.sendLink": "Mandame el enlace",
  "reset.sending": "Mandando…",
  "reset.linkSent": "Si esa cuenta existe, te mandamos un correo con el enlace.",
  "reset.done": "Listo. Ya podés entrar con tu contraseña nueva.",
  "reset.minHint": "Al menos {min} caracteres. Larga es mejor que complicada.",
  "reset.readyTitle": "Listo",

  "settings.title": "Tu cuenta",
  "settings.language": "Idioma",
  "settings.language.hint": "Aplica a este dispositivo.",
  "settings.password": "Contraseña",
  "settings.current": "Contraseña actual",
  "settings.new": "Contraseña nueva",
  "settings.change": "Cambiarla",
  "settings.changing": "Cambiando…",
  "settings.changed": "Listo, tu contraseña quedó cambiada.",

  "passkey.title": "Entrar con la huella",
  "passkey.blurb":
    "Más rápido que una contraseña, y no se puede robar con phishing: la llave nunca sale de este aparato.",
  "passkey.enable": "Activar",
  "passkey.enabling": "Esperando al dispositivo…",
  "passkey.unsupported": "Este dispositivo no lo soporta.",
  "passkey.devices": "Tus dispositivos",
  "passkey.added": "Agregado",
  "passkey.lastUsed": "Último uso",
  "passkey.never": "nunca",
  "passkey.backedUp": "Con respaldo",
  "passkey.thisDevice": "Solo este aparato",
  "passkey.rename": "Renombrar",
  "passkey.remove": "Quitar",
  "passkey.confirmRemove": "¿Quitar este dispositivo?",
  "passkey.blurbLong":
    "Registrá este dispositivo y entrás con la huella o la cara, sin escribir nada. La llave se queda en el aparato: ni nosotros la tenemos.",
  "passkey.unsupportedLong":
    "Este dispositivo no puede usar huella o cara. Podés entrar con tu contraseña.",
  "passkey.registerAnother": "Registrar este dispositivo",
  "passkey.registering": "Registrando…",
  "passkey.usedOn": "usado el {date}",
  "passkey.unused": "sin usar todavía",
  "passkey.backedUpShort": "respaldado",
  "passkey.thisDeviceOnly": "solo en este aparato",
  "passkey.removeLabel": "Quitar {label}",
  "device.iphone": "Mi iPhone",
  "device.ipad": "Mi iPad",
  "device.android": "Mi teléfono",
  "device.mac": "Mi Mac",
  "device.windows": "Mi PC",
  "device.generic": "Mi dispositivo",
  "passkey.registered": "Listo. Ya podés entrar con la huella.",

  "mode.hint.cut": "Engrosa el trazo para que aguante el weeding en vinilo.",
  "mode.hint.draw": "Deja el trazo fino: la punta de la lapicera funde el doble contorno.",
  "audit.summary.draw": "Modo dibujar: el trazo fino es lo que querés, no se engrosa.",
  "audit.summary.fail": "{pct} del trazo está bajo {mm} mm — se va a romper al weedear.",
  "audit.summary.warn": "{pct} está bajo el piso de {mm} mm — cortable con cuchilla nueva y paciencia.",
  "audit.summary.ok": "Nada por debajo de {mm} mm. Listo para cortar.",
  "fit.tooWide":
    "No entra: el lado corto mide {short} mm y la máquina corta hasta {max} mm de ancho.",
  "fit.tooLong": "Son {long} mm de largo — entra en la máquina, pero es mucho para una camisa.",
  "audit.threshold": "Umbral",
  "audit.thinnestInk": "Tinta más fina",
  "audit.nodesLabel": "nodos",
  "trace.working": "Trazando…",
  "app.loading": "Cargando…",
  "source.dropOrTap": "Soltá una imagen o tocá para elegirla",
  "source.cleaned": "Imagen limpia. Revisá el resultado antes de guardar.",
  "source.clearErased": "Quitar {count} borrados",
  "source.eraseActiveHint":
    "Arrastrá sobre el dibujo para tapar lo que no querés. Tocá un rectángulo para quitarlo.",
  "source.cleanIdleHint": "Quita el fondo y deja el diseño en negro puro sobre blanco.",
  "compare.original": "original",
  "compare.thickened": "engrosado",
  "save.savedNoImage": "Guardado, pero no pudimos archivar la imagen original.",
  "history.openedNoImage":
    "Abriste \"{name}\", pero no tiene la imagen guardada. Volvé a soltarla para re-exportarlo.",
  "history.opened": "Abriste \"{name}\". Cambiale el tamaño o el modo y volvé a descargarlo.",
  "history.openedRetry": "Abriste \"{name}\". Volvé a soltar la imagen para re-exportarlo.",
  "params.thickenLegend": "Engrosado",
  "params.floorHint": "Piso recomendado para letras y logos: {mm} mm.",
  "params.compareStroke": "Comparar con el trazo original",
  "params.outline": "Solo contorno",
  "params.outline.hint": "Rellena ojos y detalles internos: se corta o dibuja solo el borde de afuera.",
  "params.closeGaps": "Cerrar huecos",
  "params.closeGaps.hint": "Si adentro sigue apareciendo detalle, subilo: el contorno tiene un hueco en algún lado.",
  "params.largestOnly": "Solo la pieza más grande",
  "params.outlineMargin": "Margen",
  "params.outlineMargin.edge": "borde con borde",
  "params.outlineMargin.hint": "Agranda la pieza alrededor del dibujo, con esquinas redondeadas: una capa de fondo, la base de un topper. El tamaño de arriba sigue siendo el del dibujo, así las dos piezas calzan.",
  "history.outlineTag": "Contorno",
  "params.widthOption": "Ancho",
  "params.heightOption": "Alto",

  "error.bad_request": "El pedido no se entiende.",
  "error.invalid_credentials": "Correo o contraseña incorrectos.",
  "error.session_failed": "No pudimos iniciar tu sesión.",
  "error.internal": "Algo salió mal de nuestro lado.",
  "error.login_required": "Iniciá sesión para continuar.",
  "error.session_invalid": "Tu sesión no es válida. Iniciá sesión de nuevo.",
  "error.session_expired": "Tu sesión venció. Iniciá sesión de nuevo.",
  "error.file_too_large": "El archivo es demasiado grande.",
  "error.password_change_unavailable": "El cambio de contraseña no está disponible ahora mismo.",
  "error.reset_rate_limited":
    "Ya pediste varios enlaces. Esperá un momento antes de intentar de nuevo.",
  "error.reset_link_failed": "No pudimos preparar el enlace.",
  "error.reset_email_failed": "No pudimos mandar el correo. Probá de nuevo.",
  "error.reset_link_invalid":
    "Ese enlace ya venció o se usó. Pedí uno nuevo desde la pantalla de entrada.",
  "error.password_change_failed": "No pudimos cambiar tu contraseña.",
  "error.current_password_wrong": "Tu contraseña actual no es correcta.",
  "error.password_required": "Escribí una contraseña.",
  "error.password_too_short": "Esa contraseña es demasiado corta.",
  "error.password_too_long": "Esa contraseña es demasiado larga.",
  "error.passkeys_unavailable": "El acceso con passkey no está disponible ahora mismo.",
  "error.passkey_register_prepare_failed": "No pudimos preparar el registro.",
  "error.passkey_register_expired": "Se venció el registro. Probá de nuevo.",
  "error.passkey_register_failed": "No pudimos registrar este dispositivo.",
  "error.passkey_login_prepare_failed": "No pudimos preparar el acceso.",
  "error.passkey_login_expired": "Se venció el acceso. Probá de nuevo.",
  "error.passkey_login_failed": "No pudimos entrar con ese dispositivo.",
  "error.passkey_register_cancelled": "Cancelaste el registro o se agotó el tiempo.",
  "error.passkey_login_cancelled": "Cancelaste el acceso o se agotó el tiempo.",
  "error.passkey_already_registered": "Este dispositivo ya está registrado en tu cuenta.",
  "error.passkey_unsupported": "Este dispositivo no puede usar passkeys.",
  "error.passkey_insecure": "El sitio no es seguro para usar passkeys.",
  "error.passkey_list_failed": "No pudimos cargar tus dispositivos.",
  "error.passkey_not_found": "Ese dispositivo no está en tu lista.",
  "error.passkey_delete_failed": "No pudimos borrar el dispositivo.",
  "error.clean_rate_limited":
    "Estás limpiando muchas imágenes seguidas. Probá de nuevo en un momento.",
  "error.image_required": "Mandá una imagen.",
  "error.image_empty": "La imagen viene vacía.",
  "error.clean_failed":
    "No pudimos limpiar esta imagen. Probá con una donde el diseño se vea más claro.",
  "error.clean_unavailable": "El servicio de limpieza no respondió.",
  "error.design_save_failed": "No pudimos guardar el diseño.",
  "error.design_not_found": "Ese diseño no existe.",
  "error.history_load_failed": "No pudimos cargar tu historial.",
  "error.design_open_failed": "No pudimos abrir el diseño.",
  "error.design_delete_failed": "No pudimos borrar el diseño.",
  "error.blobs_unavailable": "El guardado de imágenes no está disponible ahora mismo.",
  "error.image_too_large": "La imagen es demasiado grande.",
  "error.image_save_failed": "No pudimos guardar la imagen.",
  "error.image_open_failed": "No pudimos abrir la imagen.",
  "error.image_not_found": "Este diseño no tiene la imagen guardada.",
  "error.name_required": "Ponele un nombre al diseño.",
  "error.name_too_long": "El nombre es demasiado largo.",
  "error.mode_invalid": "El modo tiene que ser cortar o dibujar.",
  "error.size_invalid": "Las medidas tienen que ser mayores que cero.",
  "error.size_too_large": "Las medidas superan lo que puede cortar la máquina.",
  "error.rotation_invalid": "La rotación tiene que ser 0, 90, 180 o 270 grados.",
  "error.svg_required": "Falta el SVG.",
  "error.thicken_invalid": "El engrosado no puede ser negativo.",
  "error.close_gaps_invalid": "Cerrar huecos tiene que estar entre 0 y 20 mm.",
  "error.outline_margin_invalid": "El margen del contorno tiene que estar entre 0 y 50 mm.",

  "error.readImage": "No pude leer la imagen: {detail}",
  "error.network": "Sin conexión. Revisá la red y probá de nuevo.",
  "error.unknown": "Algo salió mal.",
};
